import { Component } from 'react';
import OpportunityItem from '../../../Domain/OpportunityItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import OpportunityService from '../../../Services/opportunityService';
import OpportunityValidation from './OpportunityValidation';

class EditOpportunityWindowDescription extends Component {
  static titleForCreate = 'Add New Opportunity';
  static titleForEdit = 'Edit Opportunity';
  static ComponentName = 'Opportunity';

  static itemType = OpportunityItem;
  static serviceFunction = (edited) => OpportunityService.PostOpportunity(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'Opportunity',
      fields: [
        {
          fieldName: 'Name',
          label: 'Name',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'IsGlobal',
          label: 'Global',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'OfficeId',
          label: 'Owning Office',
          type: InputTypesEnum.OfficeSelect,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'ContactId',
          label: 'Contact',
          type: InputTypesEnum.ActiveContactSelect,
          validityChecker: ValidityHelper.forRequiredTextField,
          idFilter: 'ClientId',
        },
        {
          fieldName: 'IsMspartner',
          label: 'MS Partner',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'MspartnerCode',
          label: 'MS Partner',
          type: InputTypesEnum.MsPartnerSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
          hide: (item) => item.IsMspartner !== true,
        },
        {
          fieldName: 'AssignedTo',
          label: 'Assigned To',
          type: InputTypesEnum.UserSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'FollowUpByDate',
          label: 'Follow-up by Date',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Description',
          label: 'Description',
          type: InputTypesEnum.TextBox,
          tooltipText: 'Min 150 characters',
          validityChecker: EditOpportunityWindowDescription.validateDescription,
        },
      ],
    },
    {
      label: 'INVOICING',
      fields: [
        {
          fieldName: 'BillingCurId',
          label: 'Opportunity Currency',
          type: InputTypesEnum.ActiveCurrencySelect,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'SalesRepId',
          label: 'Primary Sales Rep',
          type: InputTypesEnum.UserSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          disabled: (item) => item.StatusCode && item.StatusCode !== 1,
        },
        {
          fieldName: 'AcctRepId',
          label: 'Owner',
          type: InputTypesEnum.UserSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'TypeCode',
          label: 'Opportunity Type',
          type: InputTypesEnum.OpportunityTypeLookupItemSelect,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'IndustryCode',
          label: 'Industry',
          type: InputTypesEnum.IndustryLookupItemSelect,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'NumBillToAddrs',
          label: 'No. Bill to Addresses',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'InvoicingProcedures',
          label: 'Invoicing Procedures',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
      ],
    },
    {
      label: 'Estimates',
      fields: [
        {
          fieldName: 'EstNumberOfVisits',
          label: 'Est. Number of Evaluations',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'EstValue',
          label: 'Est. Value',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'EstCloseOn',
          label: 'Est. Close On (Won or Lost Date)',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'EstStartOn',
          label: 'Est. Start On',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'EstEndOn',
          label: 'Est. End On',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'ActualCloseOn',
          label: 'Actual Close On (Won or Lost Date)',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'ActualStartOn',
          label: 'Actual Start On',
          type: InputTypesEnum.Date,
          validityChecker: OpportunityValidation.ActualStartOn,
        },
        {
          fieldName: 'ActualEndOn',
          label: 'Actual End On',
          type: InputTypesEnum.Date,
          validityChecker: OpportunityValidation.ActualEndOn,
        },
      ],
    },
  ];

  static validateDescription(e, editedItem) {
    if (e && e.length <= 150) {
      return 'Description is too short.';
    }
    return ValidityHelper.forRequiredTextField(e, editedItem);
  }
}

export default EditOpportunityWindowDescription;
